import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import {
  IndexWrapper,
  WaitListSection,
  WaitListList,
  WaitListItem,
  WaitListContracts,
  ServiceType,
} from "@framework/shared";

export const waitListRoutes: Array<RouteObject> = [
  {
    path: "/wait-list",
    children: [
      {
        index: true,
        element: (
          <IndexWrapper index="wait-list">
            <WaitListSection />
          </IndexWrapper>
        ),
      },
      {
        path: "/wait-list/contracts",
        element: <Protected />,
        children: [
          { index: true, element: <WaitListContracts service={ServiceType.OFFICE} /> },
          { path: "/wait-list/contracts/:id/:action", element: <WaitListContracts service={ServiceType.OFFICE} /> },
        ],
      },
      {
        path: "/wait-list/list",
        element: <Protected />,
        children: [
          { index: true, element: <WaitListList service={ServiceType.OFFICE} /> },

          { path: "/wait-list/list/:id/:action", element: <WaitListList service={ServiceType.OFFICE} /> },
        ],
      },
      {
        path: "/wait-list/item",
        element: <Protected />,
        children: [
          { index: true, element: <WaitListItem service={ServiceType.OFFICE} /> },

          { path: "/wait-list/item/:id/:action", element: <WaitListItem service={ServiceType.OFFICE} /> },
        ],
      },
    ],
  },
];
